import React from "react";
import "./Blogs.css";
import "../solar-insights/Solar_Insights.css";
import Free_Consultation from "../home/free-consultation/Free_Consultation";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser } from "@fortawesome/free-solid-svg-icons";
import { Blog } from "../../utils/apis/blog/Blog";
import { useContext, useEffect, useState } from "react";
import { Context } from "../../utils/context";
import { IDS } from "../../utils/common";
import Common_heading from "../common/common_heading/Common_heading";

const Blogs = () => {
  const navigate = useNavigate();
  const handleServiceClick = (id) => {
    navigate(`/blog/${id}`);
  };

  const blogData = [
    {
      id: 1,
      image: "/assets/images/home/solar_insights/img-1.png",
      author: "Shreya mishra",
      date: "10 Oct 2024",
      title: "Why Ayzair Energy Is the Smartest Investment for Indian Homes",
      desc:
        "Discover how residential Ayzair systems help homeowners reduce electricity bills, increase property value, and...",
    },
    {
      id: 2,
      image: "/assets/images/home/solar_insights/img-1.png",
      author: "Shreya mishra",
      date: "10 Oct 2024",
      title: "Why Ayzair Energy Is the Smartest Investment for Indian Homes",
      desc:
        "Discover how residential Ayzair systems help homeowners reduce electricity bills, increase property value, and...",
    },
    {
      id: 3,
      image: "/assets/images/home/solar_insights/img-1.png",
      author: "Shreya mishra",
      date: "10 Oct 2024",
      title: "Why Ayzair Energy Is the Smartest Investment for Indian Homes",
      desc:
        "Discover how residential Ayzair systems help homeowners reduce electricity bills, increase property value, and...",
    },
    {
      id: 4,
      image: "/assets/images/home/solar_insights/img-1.png",
      author: "Shreya mishra",
      date: "10 Oct 2024",
      title: "Why Ayzair Energy Is the Smartest Investment for Indian Homes",
      desc:
        "Discover how residential Ayzair systems help homeowners reduce electricity bills, increase property value, and...",
    },
    {
      id: 5,
      image: "/assets/images/home/solar_insights/img-1.png",
      author: "Shreya mishra",
      date: "10 Oct 2024",
      title: "Why Ayzair Energy Is the Smartest Investment for Indian Homes",
      desc:
        "Discover how residential Ayzair systems help homeowners reduce electricity bills, increase property value, and...",
    },
  ];

  var HtmlToReactParser = require("html-to-react").Parser;
  var htmlToReactParser = new HtmlToReactParser();

  const { IMG_URL } = useContext(Context);

  const [blog, setBlog] = useState([]);

  const getBlog = async () => {
    const res = await Blog();

    if (res?.success) {
      setBlog(res?.data?.data || []);
    }
  };

  useEffect(() => {
    getBlog();
  }, []);

  return (
    <>
      <section className="Blogs Solar_Insights">
        <div className="custom_container">
          

          <Common_heading
            heading={" Ayzair Insights & Industry Updates"}
            subHeading={
              "Expert knowledge, latest trends, and practical tips to help you  make smarter Ayzair decisions."
            }
          />

          <div className="blog_grid">
            {blog.map((blog) => (
              <div
                key={blog.id}
                className={`blog_card ${
                  blog.id <= 2 ? "blog_card_large" : "blog_card_small"
                }`}
                style={{
                  backgroundImage: `url(${IDS?.IMG_URL}${blog?.image})`,
                }}
                onClick={() => handleServiceClick(blog.id)}
              >
                <div className="blog_overlay">
                  <div className="blog_meta">
                    <FontAwesomeIcon icon={faUser} style={{ color: "#fff" }} />
                    <span className="author_name">{blog.name}</span>
                    <span className="date">
                      -{" "}
                      {new Date(blog.createdAt).toLocaleDateString("en-GB", {
                        day: "numeric",
                        month: "short",
                        year: "numeric",
                      })}
                    </span>
                  </div>

                  <h3 className="blog_title">{blog.title}</h3>
                  <p className="blog_desc">
                    {htmlToReactParser.parse(blog.description)}
                  </p>

                  <a href="#" className="read_more">
                    Read more
                  </a>
                </div>
              </div>
            ))}
          </div>

          <Free_Consultation />

          {/* <div className="blog_grid">
            {blog.map((blog) => (
              <div
                key={blog.id}
                className={`blog_card ${
                  blog.id <= 2 ? "blog_card_large" : "blog_card_small"
                }`}
                style={{
                  backgroundImage: `url(${IDS?.IMG_URL}${blog?.image})`,
                }}
                onClick={() => handleServiceClick(blog.id)}
              >
                <div className="blog_overlay">
                  <div className="blog_meta">
                    <FontAwesomeIcon icon={faUser} style={{ color: "#fff" }} />
                    <span className="author_name">{blog.name}</span>
                    <span className="date">
                      -{" "}
                      {new Date(blog.createdAt).toLocaleDateString("en-GB", {
                        day: "numeric",
                        month: "short",
                        year: "numeric",
                      })}
                    </span>
                  </div>

                  <h3 className="blog_title">{blog.title}</h3>
                  <p className="blog_desc">
                    {htmlToReactParser.parse(blog.description)}
                  </p>

                  <a href="#" className="read_more">
                    Read more
                  </a>
                </div>
              </div>
            ))}
          </div> */}
        </div>
      </section>
    </>
  );
};

export default Blogs;
